/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="18.95"
        height="18.95"
        viewBox="0 0 18.95 18.95"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M9.47 0A9.48 9.48 0 1 1 0 9.48 9.49 9.49 0 0 1 9.47 0Zm0 1a8.48 8.48 0 1 0 8.48 8.48A8.47 8.47 0 0 0 9.47 1Zm0 9.83a7 7 0 0 1 5.41 2.47l.1.12-.76.64-.1-.12a6.16 6.16 0 0 0-9.29 0l-.1.12-.77-.64.1-.12a7 7 0 0 1 5.42-2.47ZM6.29 5.77a1 1 0 1 1-1 1 1 1 0 0 1 1.01-1Zm6.34 0a1 1 0 1 1-1 1 1 1 0 0 1 1.01-1Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'FrowningFaceIcon';

export default Icon;
